export const ANOTHER_PROVIDER_BANNER_KEY = "another_provider_banner_hidden"

const getAnotherProviderBannerData = () => {
  const rawValue = localStorage.getItem(ANOTHER_PROVIDER_BANNER_KEY)
  if (!rawValue) return { pending: false, byBusinessAccountId: {} }
  if (rawValue === "true") return { pending: true, byBusinessAccountId: {} }

  try {
    return JSON.parse(rawValue)
  } catch (error) {
    return { pending: false, byBusinessAccountId: {} }
  }
}

const setAnotherProviderBannerData = (data) => {
  localStorage.setItem(ANOTHER_PROVIDER_BANNER_KEY, JSON.stringify(data))
}

export const hasProviderBanner = (businessAccountId) => {
  const data = getAnotherProviderBannerData()

  return !!businessAccountId && !!data.byBusinessAccountId?.[businessAccountId]
}

export const setProviderBanner = (businessAccountId, value) => {
  const data = getAnotherProviderBannerData()
  const nextData = {
    pending: businessAccountId ? false : !!value,
    byBusinessAccountId: { ...data.byBusinessAccountId }
  }

  if (businessAccountId) {
    if (value) {
      nextData.byBusinessAccountId[businessAccountId] = true
    } else {
      delete nextData.byBusinessAccountId[businessAccountId]
    }
  }

  setAnotherProviderBannerData(nextData)
}

export const clearProviderBanner = (businessAccountId) => {
  const data = getAnotherProviderBannerData()
  const nextData = {
    pending: false,
    byBusinessAccountId: { ...data.byBusinessAccountId }
  }

  if (businessAccountId) {
    delete nextData.byBusinessAccountId[businessAccountId]
  }

  setAnotherProviderBannerData(nextData)
}

export const bindPendingProviderBanner = (businessAccountId) => {
  const data = getAnotherProviderBannerData()
  if (!businessAccountId || !data.pending) return

  setProviderBanner(businessAccountId, true)
}
